<template>
  <div class="page-container">
    <div class="page-content checkbox-batch-container">
      <!-- Cabeçalho -->
      <div class="page-header">
        <div class="d-flex align-items-center mb-3">
          <h1 class="text-white"><i class="mdi mdi-barcode-scan"></i> Boletos</h1>
          <div class="d-flex gap-2 ml-auto align-items-center">
            <div class="checkbox-batch-toolbar">
              <button
                type="button"
                class="btn btn-outline-white"
                @click="openPaymentModal()"
              >
                <i class="fa fa-check"></i>
                <span class="d-none d-md-inline-block ml-2">
                  Marcar como pago(s)
                </span>
              </button>
            </div>
            <div class="btn-group" v-if="isMaster()">
              <button
                class="btn btn-outline-white"
                @click="openImportModal()"
                title="Importar PDF"
              >
                <i class="fa fa-upload"></i>
                <span class="d-none d-md-inline-block ml-2">Importar</span>
              </button>
            </div>
            <div class="btn-group">
              <button
                class="btn btn-outline-white"
                @click="openFilterModal()"
              >
                <i class="fa fa-filter"></i>
                <span class="d-none d-md-inline-block ml-2">Filtros</span>
              </button>
              <button
                class="btn btn-outline-white"
                @click="clearFilters()"
                title="Limpar Filtros"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Corpo -->
      <div class="page-body">
        <div class="card bg-light-gray">
          <div class="card-body pt-1">
            <DatatableBillets
              ref="datatableBillets"
              :filters="filters"
              @toggle-billet-selection="updateSelectedBillets"
              @open-single-billet-modal="openSingleBilletModal"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Confirmar Pagamento -->
    <b-modal
      id="modal-confirm-payment"
      ref="confirmModalPayment"
      size="lg"
      hide-footer
      centered
    >
      <template #modal-title>
        <h5 class="modal-title">Confirmar pagamento</h5>
      </template>
      <div class="modal-content" style="border:0">
        <div class="modal-body">
          <p>
            Você confirma o pagamento do(s) seguinte(s) boleto(s)?
          </p>
          <div class="card">
            <div class="card-body bg-light-gray p-3">
              <div class="table-responsive">
                <table
                  role="table"
                  aria-busy="false"
                  aria-colcount="9"
                  class="table-v3"
                >
                  <thead role="rowgroup">
                    <tr>
                      <th class="nowrap">Nro. Ap.</th>
                      <th class="nowrap">CNPJ TOMADOR</th>
                      <th class="nowrap">VALORES</th>
                      <th class="nowrap text-center">DATAS</th>
                    </tr>
                  </thead>
                  <tbody role="rowgroup">
                    <tr
                      v-for="(billet, idx) in selectedBillets"
                      :key="idx"
                      role="row"
                      style="--small-badge-width:5ch"
                    >
                      <td data-column-title="Nro. da Apólice">
                        {{ billet.number }}
                      </td>
                      <td data-column-title="CNPJ do Tomador">
                        {{ billet.policy_holder_document | formatDocument }}
                      </td>
                      <td data-column-title="Valores">
                        <div class="d-flex flex-column">
                          <span class="nowrap">
                            <span
                              class="badge badge-secondary"
                              style="width:var(--small-badge-width)"
                              title="Importância Segurada"
                            >
                              I.S
                            </span>
                            {{ formatCurrency(billet.coverage_value) }}
                          </span>
                          <span class="nowrap">
                            <span
                              class="badge badge-secondary"
                              style="width:var(--small-badge-width)"
                              title="Prêmio"
                            >
                              PR
                            </span>
                            {{ formatCurrency(billet.insurance_premium) }}
                          </span>
                        </div>
                      </td>
                      <td data-column-title="Vencimento" style="--small-badge-width:4ch">
                        <div class="d-flex flex-column align-items-center">
                          <span class="d-flex align-items-center">
                            <span
                              class="badge badge-secondary"
                              style="width:var(--small-badge-width)"
                              title="Vencimento"
                            >
                              V
                            </span>
                            <span class="ml-1">{{ billet.end_date }}</span>
                          </span>
                          <span class="d-flex align-items-center mt-1">
                              <span class="badge badge-secondary" data-toggle="tooltip" title=""
                                    style="width: var(--small-badge-width);" data-original-title="Prorrogado para">P</span>
                              <span class="ml-2">{{ billet.extended_date }}</span>
                            </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <footer class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="$bvModal.hide('modal-confirm-payment')"
            >
              <i class="fa fa-times mr-1"></i> Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="markBilletAsPaid()"
            >
              <i class="fa fa-check mr-1"></i> Confirmar
            </button>
          </footer>
        </div>
      </div>
    </b-modal>

    <!-- Modal Filtros -->
   <b-modal id="filter-modal" ref="filterModal" size="md" hide-footer centered>
      <template #modal-title>Filtros</template>

      <div class="form-group">
        <label for="filterPolicyHolder">Tomador</label>
        <b-form-input
          v-model="filters.policy_holder"
          @input="filterSuggestions('policy_holder', filters.policy_holder)"
          placeholder="Digite o nome do tomador"
        />
        <ul v-if="policyHolderSuggestions.length" class="autocomplete-list">
          <li
            v-for="(name, index) in policyHolderSuggestions"
            :key="index"
            @click="selectSuggestion('policy_holder', name)"
          >
            {{ name }}
          </li>
        </ul>
      </div>

      <div class="form-group">
        <label for="filterInsured">Segurado</label>
        <b-form-input
          v-model="filters.insured"
          @input="filterSuggestions('insured', filters.insured)"
          placeholder="Digite o nome do segurado"
        />
        <ul v-if="insuredSuggestions.length" class="autocomplete-list">
          <li
            v-for="(name, index) in insuredSuggestions"
            :key="index"
            @click="selectSuggestion('insured', name)"
          >
            {{ name }}
          </li>
        </ul>
      </div>

      <div class="form-group">
        <label>Seguradora</label>
        <b-form-select v-model="filters.insurer">
          <b-form-select-option :value="null">Sem Filtro</b-form-select-option>
          <b-form-select-option v-for="(value, index) in listInsurers" :value="index" :key="index">
            {{ value }}
          </b-form-select-option>
        </b-form-select>
      </div>

      <div class="form-group">
        <label for="filterPolicyNumber">Status</label>
        <b-form-select v-model="filters.status_id" class="mb-3">
          <b-form-select-option v-for="(value, index) in options()" :value="value.value" :key="index">
            {{ value.text }}
          </b-form-select-option>

        </b-form-select>
      </div>

      <div class="d-block mt-3">
        <div class="d-flex justify-content-between">
          <b-button variant="outline-secondary" @click="$bvModal.hide('filter-modal')">
            Cancelar
          </b-button>
          <b-button variant="primary" @click="applyFilters()">
            Aplicar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="import-acrisure-modal"
      ref="importAcrisureModal"
      size="md"
      hide-footer
      centered
      @hide="resetImportForm"
    >
      <template #modal-title>
        <i class="fa fa-upload mr-2"></i>
        Importar Boleto PDF
      </template>

      <div class="alert alert-info mb-3">
        <small>
          Selecione o arquivo PDF do boleto e informe o número da apólice correspondente.
        </small>
      </div>

      <form @submit.prevent="submitImportAcrisure">
        <div class="form-group">
          <label for="acrisureNumber" class="font-weight-bold">
            <i class="fa fa-file-text-o mr-1"></i>
            Número da Apólice *
          </label>
          <b-form-input
            id="acrisureNumber"
            v-model.trim="importForm.acrisure_policy_number"
            placeholder="Ex.: 123456789"
            :state="importForm.acrisure_policy_number ? true : null"
            required
          />
          <small class="text-muted">
            Informe o número da apólice que será vinculada ao boleto
          </small>
        </div>

        <div class="form-group">
          <label for="acrisurePdf" class="font-weight-bold">
            <i class="fa fa-file-pdf-o mr-1"></i>
            Arquivo PDF *
          </label>
          <b-form-file
            id="acrisurePdf"
            accept=".pdf,application/pdf"
            :multiple="false"
            :state="importForm.pdf ? true : null"
            @change="handlePdfChange"
            browse-text="Selecionar PDF"
            placeholder="Selecione um arquivo PDF..."
            drop-placeholder="Arraste o PDF aqui..."
          />
          <small class="text-muted d-block mt-1">
            <i class="fa fa-exclamation-triangle mr-1"></i>
            Apenas arquivos PDF (máximo 10 MB)
          </small>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-4">
          <b-button 
            variant="outline-secondary" 
            @click="$bvModal.hide('import-acrisure-modal')" 
            :disabled="importLoading"
          >
            <i class="fa fa-times mr-1"></i>
            Cancelar
          </b-button>
          <b-button 
            variant="primary"
            type="submit"
            :disabled="!canSubmitImport || importLoading"
          >
            <span v-if="importLoading">
              <i class="fa fa-spinner fa-spin mr-1"></i> 
              Processando...
            </span>
            <span v-else>
              <i class="fa fa-upload mr-1"></i>
              Importar Boleto
            </span>
          </b-button>
        </div>
      </form>
    </b-modal>


  </div>
</template>

<script>
import DatatableBillets from './DatatableBillets.vue';
import policyService from "@/services/policy";
import billetService from "@/services/billet";
import numericFormatterMixin from "@/mixins/numericFormatter";
import authenticationService from "@/services/authentication";

export default {
  name: "ListBillets",
  mixins: [numericFormatterMixin],
  components: {
    DatatableBillets,
  },
  data() {
    return {
      itemsPolicies: [],
      itemsPolicyRenovation: [],
      selectedBillets: [],
      listInsurers: [],
      loading: false,
      filters: {
        policy_holder: '',
        insured: '',
        status_id: null,
      },
      policy_holder_names: [],
      insured_names: [],
      policyHolderSuggestions: [],
      insuredSuggestions: [],
      isPolicyHolderFocused: false,
      isInsuredFocused: false,
      importForm: {
        acrisure_policy_number: '',
        pdf: null,
      },
      importLoading: false,
    };
  },
  created() {
    this.getInsurers();
    this.getPolicyHolderAndInsuredName();
  },
    mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
  computed: {
    canSubmitImport() {
      return this.importForm.acrisure_policy_number && 
             this.importForm.acrisure_policy_number.trim() !== '' && 
             this.importForm.pdf;
    }
  },
  methods: {
    openImportModal() {
      this.resetImportForm();
      this.$bvModal.show('import-acrisure-modal');
    },
    handlePdfChange(e) {
      const file = (e && e.target && e.target.files && e.target.files[0]) ? e.target.files[0] : null;
      
      if (file) {
        // Validar tipo de arquivo
        if (file.type !== 'application/pdf') {
          this.$bvToast.toast('Por favor, selecione apenas arquivos PDF.', {
            title: 'Arquivo Inválido',
            variant: 'warning',
            solid: true
          });
          this.importForm.pdf = null;
          return;
        }
        
        // Validar tamanho (10MB)
        if (file.size > 10 * 1024 * 1024) {
          this.$bvToast.toast('O arquivo deve ter no máximo 10MB.', {
            title: 'Arquivo muito grande',
            variant: 'warning',
            solid: true
          });
          this.importForm.pdf = null;
          return;
        }
        
        this.importForm.pdf = file;
      } else {
        this.importForm.pdf = null;
      }
    },
    resetImportForm() {
      this.importForm.acrisure_policy_number = '';
      this.importForm.pdf = null;
      this.importLoading = false;
    },
    async submitImportAcrisure() {
      if (!this.canSubmitImport) {
        this.$bvToast.toast('Por favor, preencha todos os campos obrigatórios.', {
          title: 'Campos obrigatórios',
          variant: 'warning',
          solid: true
        });
        return;
      }

      try {
        this.importLoading = true;
        const formData = new FormData();
        formData.append('acrisure_policy_number', this.importForm.acrisure_policy_number);
        formData.append('pdf', this.importForm.pdf);

        const response = await billetService.importAcrisure(formData);

        this.$bvToast.toast('Boleto importado com sucesso!', {
          title: 'Importação Concluída',
          variant: 'success',
          solid: true
        });

        this.$bvModal.hide('import-acrisure-modal');
        
        // Recarregar a lista de boletos
        if (this.$refs.datatableBillets && this.$refs.datatableBillets.fetchBillets) {
          this.$refs.datatableBillets.fetchBillets(this.filters);
        }
      } catch (error) {
        console.error('Erro ao importar boleto:', error);
        
        let errorMessage = 'Falha ao importar o boleto.';
        if (error.response && error.response.data) {
          if (error.response.data.error) {
            errorMessage = error.response.data.error;
          } else if (error.response.data.errors) {
            // Tratar erros de validação
            const errors = Object.values(error.response.data.errors).flat();
            errorMessage = errors.join(' ');
          }
        }
        
        this.$bvToast.toast(errorMessage, {
          title: 'Erro na Importação',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000
        });
      } finally {
        this.importLoading = false;
      }
    },
    isMaster() {
      return authenticationService.isMaster();
    },
    markBilletAsPaid() {
      const selectedBilletIds = this.selectedBillets.map(billet => billet.id);
      if (selectedBilletIds.length === 0) {
        return;
      }
      this.loading = true;

      billetService.markAsPaid({ billets: selectedBilletIds })
        .then(() => {
          this.$refs.datatableBillets.fetchBillets();
          this.selectedBillets = [];
        })
        .catch((e) => {
          console.error(e);
        }).finally(() => {
          this.loading = false;
          this.$bvModal.hide('modal-confirm-payment');
        });
    },
    applyFilters() {
      this.$bvModal.hide('filter-modal');
      this.$refs.datatableBillets.fetchBillets(this.filters);
    },
    updateSelectedBillets(billet) {
      const index = this.selectedBillets.findIndex(b => b.id === billet.id);
      if (index === -1) {
        this.selectedBillets.push(billet);
      } else {
        this.selectedBillets.splice(index, 1);
      }
    },
    openSingleBilletModal(billet) {
      this.selectedBillets = [billet];
      this.$bvModal.show("modal-confirm-payment");
    },
    openPaymentModal() {
      if (this.selectedBillets.length === 0) {
        return;
      }
      this.$bvModal.show("modal-confirm-payment");
    },
    openFilterModal() {
      this.$bvModal.show('filter-modal');
    },
    clearFilters() {
      this.filters.policy_holder = '';
      this.filters.insured = '';
      this.filters.status_id = '';
      this.filters.insurer = '';
      this.$refs.datatableBillets.fetchBillets();
    },
    setLoading(status) {
      this.loading = status;
    },
    getInsurers() {
      policyService
        .getInsurers()
        .then((response) => {
          this.listInsurers = response.data;
        })
        .catch(() => {
          this.showError("Não foi possível recuperar a lista de seguradoras.");
        });
    },
    options() {
      let options = [];
      let status = Object.entries({
        'Pago': 19,
        'Vencido': 20,
        'Em aberto': 21
      });
      status.forEach((element) => {
        options.push({ value: element[1], text: element[0] });
      });
      options.sort(function (a, b) {
        return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
      });
      options.splice(0, 0, {
        value: null,
        text: "Sem Filtro",
        notEnabled: true,
        disabled: true,
      });
      return options;
    },
    getPolicyHolderAndInsuredName() {
      billetService.getPolicyHolderAndInsuredNames()
      .then((response) => {
        this.policy_holder_names = response.data.policy_holders;
        this.insured_names = response.data.insured_names;
      })
      .catch(() => {
        this.showError("Não foi possível recuperar a lista tomadores e segurados na aba de boleto.");
      });
    },
    handleOutsideClick(event) {
      if (!this.$refs.policyHolderInput?.contains(event.target) && !event.target.closest('.autocomplete-list')) {
        this.policyHolderSuggestions = [];
      }
      if (!this.$refs.insuredInput?.contains(event.target) && !event.target.closest('.autocomplete-list')) {
        this.insuredSuggestions = [];
      }
    },

    filterSuggestions(type, query) {
      if (query.length < 3) {
        if (type === 'policy_holder') {
          this.policyHolderSuggestions = [];
        } else if (type === 'insured') {
          this.insuredSuggestions = [];
        }
        return;
      }

      if (type === 'policy_holder') {
        this.policyHolderSuggestions = this.policy_holder_names.filter(name =>
          name.toLowerCase().includes(query.toLowerCase())
        );
      } else if (type === 'insured') {
        this.insuredSuggestions = this.insured_names.filter(name =>
          name.toLowerCase().includes(query.toLowerCase())
        );
      }
    },
  selectSuggestion(type, name) {
    if (type === 'policy_holder') {
      this.filters.policy_holder = name;
      this.policyHolderSuggestions = [];
    } else if (type === 'insured') {
      this.filters.insured = name;
      this.insuredSuggestions = [];
    }
  },
  }
};
</script>

<style scoped>
.alert-info {
  background-color: #e3f2fd;
  border-color: #bbdefb;
  color: #1976d2;
}

.font-weight-bold {
  font-weight: 600 !important;
}

.form-group label {
  margin-bottom: 0.5rem;
  color: #495057;
}

.btn[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

.autocomplete-list {
  position: absolute;
  z-index: 1000;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
}

.autocomplete-list li {
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}

.autocomplete-list li:hover {
  background-color: #f8f9fa;
}

.autocomplete-list li:last-child {
  border-bottom: none;
}
</style>
